import React, { useState } from "react";
import { View, StyleSheet, TouchableWithoutFeedback, TouchableOpacity, Image, Dimensions  } from "react-native";
//import { Image } from "react-native-expo-image-cache";
import { Video, AVPlaybackStatus } from 'expo-av';

import Text from "./Text";
import colors from "../config/colors";
import textStyles from "../config/textStyles";
import { MaterialCommunityIcons, Entypo, Foundation,FontAwesome,FontAwesome5 } from "@expo/vector-icons";
import { ListItemAccount } from "./lists";
import CardFeedType from "./CardFeedType";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import routes from "../navigation/routes";
import CardFeedContent from "./CardFeedContent";
import dateActions from "../utility/dateActions";

var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
console.log('windowWidth ', windowWidth )
function CardFeed({ 
  
    alias,
  userDescription,
  title,
  subTitle,
  imageUrl,
  onPress,
  onPressLike,
  onPressComment,
  onPressNumLikes,
  thumbnailUrl,
  commentsNum,
  actionsNum,
  userPhoto,
  userPhotoFoundUser,
  userName,
  seedDescription,
  type,
  onPressShare,
  userId,
  statusLike,
  createDateSeed,
  onPressFolloresSeed,
  followersSeed,
  seedNameOrigin,
  seedDescriptionOrigin,
  seedPhotoOrigin,
  seedId,
  seedTotalActionsOrigin,
  seedTotalSeedLikesOrigin,
  seedTotalSeedFollowersOrigin,
  typeOrigin, 
  origin,
  onPressForOrigin,
  youtubeId,
  originOfOrigin,
  //......
  qty,
  mesure,
  unitaryPrice,
  currency,
  sub,
  note
                }) { 
//console.log('ejemplo de ->', type)

const video =React.useRef(null);
const navigation = useNavigation()
const [status, setStatus] = useState({});
const [verMas, setVerMas] = useState(false);

var dateFormated = dateActions(createDateSeed)


switch (type) {
    case -1: 
    return (
        <View style={styles.card}>
        {/* <TouchableOpacity onPress={onPress}> */}
          <View>
            {onPressShare&& 
            <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} />
            }
            <View style={styles.viewIconAndNameAction}> 
            <View style={styles.iconOfAction0}> 
                              <FontAwesome
                                //style={styles.iconOfAction0}
                                name={"photo"}
                                size={15}
                                onPress={() => navigation.navigate(routes.LISTING_EDIT)}
                              />                                 
                </View>
                     <Text style={styles.actionName}> Publicación </Text>
            </View>       
          {seedDescription.length > 150 ?
          <Text style={styles.seedDescription} 
                    numberOfLines={5}
                    onPress={ () => {
                        setVerMas(true)

                        console.log('ver más :) _', verMas)
                    }
          }>
                {seedDescription.substring(0, 200)} ... ver mas
          </Text>
        //   : verMas === true ?
        //   <Text style={styles.seedDescription} 
        //     onPress={ () => {
        //         console.log('ver más :) _')
        //         setVerMas = false
        //     }
        //     }>
        //         {seedDescription} ... ver menos
        //   </Text>
          :
          <Text style={styles.seedDescription} >
                {seedDescription}
          </Text>
          }

          {  
            imageUrl.includes('.mp4') ?
            <Video 
            ref = {video}
            style = {styles.image}
            source = {{
              uri: imageUrl
            }}
            useNativeControls
            resizeMode = "contain"
            isLooping
            onPlaybackStatusUpdate = {status => setStatus(() => status)}
            />
            :
            imageUrl.includes('.mov') ?
            <Video 
            ref = {video}
            style = {styles.image}
            source = {{
              uri: imageUrl
            }}
            useNativeControls
            resizeMode = "contain"
            isLooping
            onPlaybackStatusUpdate = {status => setStatus(() => status)}
            />
            : 
            imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
            <View style={styles.imageMountain} >
                        <Foundation //style={styles.imageMountain}
                                    name="mountains" 
                                    size={350} 
                                    color={colors.medium} />
            </View>
            :  
            <TouchableOpacity  
               onPress={ () => {
              console.log('pique la imagen', )
              
              navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
              }}>  

            <Image
              style={ windowWidth > 200 ? styles.imageWeb  : styles.image  }
             // tint="light"
              //preview={{ uri: thumbnailUrl }}
              //uri={imageUrl}
              source={{uri: imageUrl}}
              resizeMode="stretch"              


            />
            </TouchableOpacity>   
          }
          </View>
          <ListItemAccount         
            titleRol={userName}
            image={userPhoto}

          />
        {/* </TouchableOpacity> */}
        <View style={styles.detailsContainer}>

             <View style={styles.likeAndCommentContainer}> 
                    <Text style={styles.subTitle} // Número de cerebros like
                          numberOfLines={2} 
                          onPress={onPressNumLikes}>
                          {subTitle}
                    </Text>
                    <Text style={styles.commentsNum} // Número de comments
                          numberOfLines={1} >
                          {commentsNum}
                    </Text>

              </View>
              <View style={styles.likeAndCommentContainer}> 
                    <MaterialCommunityIcons name={"brain"} 
                                            color={"red"} 
                                            size={27} 
                                            onPress={onPressLike}
                    />
                  <Text style={styles.comments} numberOfLines={1} >
                      <MaterialCommunityIcons name={"comment-text-outline"} 
                                              color={"grey"} 
                                              size={27} 
                                              onPress={onPressComment} 
                      /> 
                  </Text>

              </View>
        </View>
  </View>

    )
    case 0: 
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    )
    case 1:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 2:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 3:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 4:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 5:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 6:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 7:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 8:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    case 9:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
// Add text  <===  L I S T O !!
    case 33:
      return (
        // <CardFeedType
        // title={title}
        // subTitle={subTitle} // 
        // seedDescription = {seedDescription}
        // userPhoto={userPhoto }
        // userName={userName}
        // type={type}
        // onPressNumLikes={onPressNumLikes}
        // imageUrl={imageUrl}
        // onPress={onPress}
        // onPressLike={onPressLike }
        // commentsNum={commentsNum}
        // actionsNum={actionsNum}
        // onPressComment={onPressComment}
        // thumbnailUrl={thumbnailUrl}
        // onPressShare={onPressShare}
        // />
         <CardFeedContent
          title={title}
          subTitle={subTitle} // 
          seedDescription={seedDescription}
          userPhoto={userPhoto}
          userPhotoFoundUser={userPhotoFoundUser}
          userName={userName}
          type={type}
          onPressNumLikes={onPressNumLikes}
          imageUrl={imageUrl}
          onPress={onPress}
          onPressLike={onPressLike}
          commentsNum={commentsNum}
          actionsNum={actionsNum}
          onPressComment={onPressComment}
          thumbnailUrl={thumbnailUrl}
          onPressShare={onPressShare}
          userId={userId}
          alias={alias}
          userDescription={alias}
          statusLike={statusLike}
          createDateSeed={dateFormated}
          onPressFolloresSeed={onPressFolloresSeed}
          followersSeed={followersSeed}
          seedNameOrigin={seedNameOrigin}
          seedDescriptionOrigin={seedDescriptionOrigin}
          seedPhotoOrigin={seedPhotoOrigin}
          seedTotalActionsOrigin={seedTotalActionsOrigin}  
          seedTotalSeedLikesOrigin={seedTotalSeedLikesOrigin}  
          seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}  
          typeOrigin={typeOrigin}
          onPressForOrigin={onPressForOrigin}
          seedId={seedId}
        />
      );

// Add document <==================  SOLO F A L T A QUE NO TRUENE AL HACER GRANDE LOS ARCHIVOS EN EXCELL 5 SEP 2021 
    case 34:
      return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
);

// Add photo or Video  <===  L I S T O !!
    case 35:
        return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
        );
    
// Add photo or Video to right and Text to the  ==> L E F T <==  L I S T O!!     
    case 36:
        return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
        );

 // Add photo or Video  with Text to the ==> R I G H T <==  L I S T O!!     
    case 37:
          return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
          );

//  Add     Y O U T U B E  V I D E O     <===  L I S T O!!    
    case 38:
            return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
            );

// Add    R E Q U I R E M E N T     
    case 39:
        return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />      
      );
    
// Add  S U B - R E Q U I R E M E N T      
    case 40:
          return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
          );

// Add  S U B - S U P P O R T   apoyo        
    case 41:
        return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
        );
      break;

//Multiples photos or Videos  <===  :) !!      
    case 44:
        return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
        );

// Add  S U B - S U P P O R T  Le cambie el case de 41 a 77 para hacer pruebas       
    case 77:
      return (
        <CardFeedType
          title={title}
          subTitle={subTitle} // 
          seedDescription={seedDescription}
          userPhoto={userPhoto}
          userPhotoFoundUser={userPhotoFoundUser}
          userName={userName}
          type={type}
          onPressNumLikes={onPressNumLikes}
          imageUrl={imageUrl}
          onPress={onPress}
          onPressLike={onPressLike}
          commentsNum={commentsNum}
          actionsNum={actionsNum}
          onPressComment={onPressComment}
          thumbnailUrl={thumbnailUrl}
          onPressShare={onPressShare}
          userId={userId}
          alias={alias}
          userDescription={alias}
          statusLike={statusLike}
          createDateSeed={dateFormated}
          onPressFolloresSeed={onPressFolloresSeed}
          followersSeed={followersSeed}

        />
      );
    
    case 39:   
    return (
        <CardFeedType
        title={title}
        subTitle={subTitle} // 
        seedDescription = {seedDescription}
        userPhoto={userPhoto }
        userName={userName}
        type={type}
        onPressNumLikes={onPressNumLikes}
        imageUrl={imageUrl}
        onPress={onPress}
        onPressLike={onPressLike }
        commentsNum={commentsNum}
        actionsNum={actionsNum}
        onPressComment={onPressComment}
        thumbnailUrl={thumbnailUrl}
        onPressShare={onPressShare}
         />
    );
    break;
    }
}


const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    backgroundColor: colors.fondoGeneral,
    marginBottom: 15,
    overflow: "hidden",
    width:'94%',
    alignSelf:'center',
  },
  viewIconAndNameAction: {
    flexDirection: "row",
    alignSelf: "flex-start", 
    //backgroundColor: "blue", 
    alignItems: "center",
   // width:'60%',
    marginLeft: "3.5%",
  },
  detailsContainer: {
    padding: 20,
  },
  image: {
    width: 400,
    height: 400,
  },
  imageWeb: {
    marginLeft:'10%',
    width: '80%',
    height: 250,
  },
  // image: {
  //   marginTop: "2%",
  //   width:  (windowWidth*.500),     //120,  // Para que funcione resizeMode= "stretch" en las propiedades de ImageCache arriba tanto width como heigth deben estar en pixeles, ninguno en porcentajes.
  //   //width:   120,
  //   height: (windowHeight*.5510),    //120, 
  //   //height:  120, 
  //   backgroundColor: colors.chakra8tur,
  // },
  imageMountain: {
    width: "100%",
    height: 250,
    alignItems: "center"
  },
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: 40,
  },
  likes: {
    marginLeft: "20%",
 },
  actionsNum:{
  marginLeft: "42%",
  color: colors.medium
 },
 commentsNum:{
  marginLeft: "37.5%",
  color: colors.medium
 },
 comments:{
  marginLeft: "35%",
  color: colors.medium,

 },
 tree:{
  marginLeft: "35%",
  color: colors.medium,
 },
  subTitle: {
    color: colors.medium,
    marginLeft: "2%"
  },
  title: {
    marginBottom: 7,
    //fontSize: 50,
    fontWeight: "bold",
    alignSelf: "center"

  },
  seedDescription:{
    marginBottom: 7,
    textAlign: "center",

    //fontSize: 50,
   // fontWeight: "bold" 
  },
  iconOfAction0: { 
    height: 35,//(windowWidth * .08),   
    width: 35,//(windowWidth * .08),  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "#8DF78D",    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 1,
   // alignSelf: "flex-end",
    //marginLeft: "2%", 
   // marginRight: "2%", 
    marginTop: 3,
    backgroundColor: "#EBAB91"  
    },
    actionName: {
      fontSize: textStyles .textSmall,
      color: colors.textGeneral,
     // marginTop: "2%",
      //textAlignVertical: "bottom",
      marginBottom: "9.5%",
      marginLeft:'15%'
    },
});

export default CardFeed;
